import { TrackingUserActivityType } from './Tracking'

export class MarkerPosition {
  lat: number
  lng: number
  alt: number
  label?: string

  constructor (lat: number, lng: number, alt?: number, label?: string) {
    this.lat = lat
    this.lng = lng
    this.alt = alt || 0
    this.label = label
  }

  hasValue () {
    return this.lat !== 0 || this.lng !== 0
  }

  static fromString (position: string) {
    if (!position) return new MarkerPosition(0, 0)
    const parts = position.split(',')
    return new MarkerPosition(Number(parts[0]), Number(parts[1]))
  }

  haversineDistance (position: MarkerPosition) {
    const R = 6378 // Radius of the Earth in KM
    const rlat1 = this.lat * (Math.PI / 180) // Convert degrees to radians
    const rlat2 = position.lat * (Math.PI / 180) // Convert degrees to radians
    const difflat = rlat2 - rlat1 // Radian difference (latitudes)
    const difflon = (position.lng - this.lng) * (Math.PI / 180) // Radian difference (longitudes)

    const d = 2 * R * Math.asin(
      Math.sqrt(
        Math.sin(difflat / 2) * Math.sin(difflat / 2) +
        Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)
      ))
    return d
  }
}

export class LongMarkerPosition {
  latitude: number
  longitude: number
  altitude: number

  constructor (lat: number, lng: number, alt?: number) {
    this.latitude = lat
    this.longitude = lng
    this.altitude = alt || 0
  }
}

export class Marker {
  position: MarkerPosition
  animation: number
  visible = true

  constructor (lat?: number, lng?: number) {
    this.animation = 0
    if (lat && lng) {
      this.position = new MarkerPosition(lat, lng)
    }
  }
}

export class MarkerLabel {
  text: string
  color: string
  fontWeight: string
  fontSize: string
}

export class Point {
  x: number
  y: number

  constructor (x?: number, y?:number) {
    this.x = x || 0
    this.y = y || 0
  }
}

export class MarkerIcon {
  url: string
  labelOrigin: Point
}

export class UserMarker extends Marker {
  id: number
  user: string
  name: string
  groups: string
  status: number
  mock: boolean
}

export class TaskMarker extends Marker {
  id: number
  name: string
  status: number
  receivedDate: string
}

export class PathMarker extends Marker {
  id: string
  time: string
  timestamp: number
  device: string
  mock: boolean
  heading: number
  gpsOn: boolean
  gpsOff: boolean
  activityType: TrackingUserActivityType
}

export class SnapPoint {
  location: LongMarkerPosition
  originalIndex: number
  placeId: string
}

export class SnapToRoadResponse {
  snappedPoints: SnapPoint[]
}

export class Direction {
  duration: number
  distance: number
  geometry: {
    coordinates: Array<Array<number>>
  }
}

export class DirectionsReponse {
  routes: Direction[]
}
